import { useEffect,useState } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { Switch,Route,Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import CreateUserForm from './CreateUserForm'
import ShowAllUsers from './ShowAllUsers';
import Responsibilities from './Responsibilities';
import Equipments from './Equipments';
import Units from './Units';
import Articles from '../Admin/Articles';
import ArticlesNew from '../Admin/ArticlesNew';
import ArticleCreatePage from '../Admin/ArticlesNew/ArticleCreatePage';
import ArticleEditPage from '../Admin/ArticlesNew/ArticleEditPage';
import AuditLog from './AuditLog';
import OfferFields from './OfferFields';
import OfferConditions from './OfferConditions';
import MeasurmentSketchTemplate from './MeasurmentSketchTemplate';
import {checkIfUserIsAuthorized} from "./globalFunctions";
import {toast} from "react-toastify";
import ColorPalettes from "./ColorPalettes";
import Materials from './Materials';
import Suppliers from './Suppliers'
import ProductionSettings from './ProductionSettings'
import ImpressionQuestions from "./ImpressionQuestions";
import Page404 from "../Page404";
import Departments from "./Departments";
import { t } from "../../i18n";
import UsersDashboard from "./UsersDashboard/UsersDashboard";
import CompanyProfile from './CompanyProfile';
import OfferSettings from './OfferSettings';
import ReturnCategories from './ReturnCategories';
import InstallationBlockCategories from './InstallationBlockCategories';
import ServicingTypes from './ServicingTypes';
import KubitIntegration from './KubitIntegration';

interface Props {
    intl: any;
    permissions: any;
    history: any;
    actions: any;
    companyProfile?: { kubitEnabled?: boolean } | null;
}

const Admin = (props: Props) => {

    useEffect(()=>{
        props.actions.getUserPermissionsAndResponsibilities()
    },[])

    useEffect(()=>{
        console.log(props.permissions,'props.permissions')
        if(Object.keys(props.permissions).length !== 0 && !checkIfUserIsAuthorized(props.permissions, props.permissions?.fullPrivileges, false)){
            toast.error(t('admin.toast.notAuthorized'))
            props.history.push('/dashboard/contact')
        }
    }, [props.permissions])

    return (
        <div className="admin-page-container">
            <Switch>
                <Route exact path="/admin" component={UsersDashboard} />
                <Route exact path="/admin/all-users" component={ShowAllUsers} />
                <Route exact path="/admin/create-user/:userId?" component={CreateUserForm} />
                <Route exact path="/admin/responsibilities" component={Responsibilities} />
                <Route exact path="/admin/departments" component={Departments} />
                <Route exact path="/admin/equipments" component={Equipments} />
                <Route exact path="/admin/units" component={Units} />
                <Route exact path="/admin/articles-legacy" component={Articles} />
                <Route exact path="/admin/articles" component={ArticlesNew} />
                <Route exact path="/admin/articles/new" component={ArticleCreatePage} />
                <Route exact path="/admin/articles/:id" component={ArticleEditPage} />
                <Route exact path="/admin/suppliers" component={Suppliers} />
                <Route exact path="/admin/audit-log" component={AuditLog} />
                <Route exact path="/admin/measurement-sketch-templates" component={MeasurmentSketchTemplate} />
                <Route exact path="/admin/color-palettes" component={ColorPalettes} />
                <Route exact path="/admin/offer-settings" component={OfferSettings} />
                <Route exact path="/admin/offer-fields" component={OfferFields} />
                <Route exact path="/admin/offer-conditions" component={OfferConditions} />
                <Route exact path="/admin/impression-questions" component={ImpressionQuestions} />
                <Route exact path="/admin/materials" component={Materials} />
                <Route exact path="/admin/production-settings" component={ProductionSettings} />
                <Route exact path="/admin/return-categories" component={ReturnCategories} />
                <Route exact path="/admin/installation-block-categories" component={InstallationBlockCategories} />
                <Route exact path="/admin/servicing-types" component={ServicingTypes} />
                <Route exact path="/admin/company-profile" component={CompanyProfile} />
                <Route
                    exact
                    path="/admin/integrations/kubit"
                    render={() => (
                        // Per-tenant gate (Mika Ops kubit_enabled flag).
                        // Default false. While companyProfile is still
                        // loading we render nothing instead of redirecting
                        // — prevents a flash-redirect for legitimate users.
                        props.companyProfile === null
                            ? null
                            : (props.companyProfile?.kubitEnabled
                                ? <KubitIntegration />
                                : <Redirect to="/dashboard/contact" />)
                    )}
                />
                <Route render={()=><Page404/>}/>
            </Switch>
        </div>
    )
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Admin as any)))